export default __webpack_public_path__ + "static/media/newYorkJets@2x.bcec1c60.jpg";